
import { recursivelyFindingNavigationItem } from '../tools/recursivelyFindingNavigationItem'
import {deepSearchWidget} from '../tools/widgetContainerTools'
export default {
  computed: {
    // Текущий модуль
    module() {
      return this.$route.params.module
    },
    changedModel() {
      return this.$store.getters.getChangedModel
    }
  },
  methods: {
    // Получение значения из измененной модели
    getValueFromChangedModel(propName, localValue) {
      let changedModel = this.changedModel
      if (!this.changedModel || !changedModel['Modules'] || !changedModel['Modules'][this.module] || !changedModel['Modules'][this.module].WidgetPropertiesOverrides) {
        return localValue[propName]
      }
      
      let widget = changedModel['Modules'][this.module].WidgetPropertiesOverrides.find(x => x['$ID'] === localValue['$ID'])
      if (!widget) {
        return localValue[propName]
      }
      return widget[propName] || localValue[propName]
    },
    // Обновление навигации в changedModel
    updateNavigationInChangedModel(propName, propValue, localValue) {
      let navigation = this.$store.state.appModels.changedModel.Navigation
      if (!navigation || !navigation.Menu || !navigation.Menu.length) {
        return
      }

      // Поиск элемента навигации
      let navItem = recursivelyFindingNavigationItem(navigation.Menu, localValue.$ID)
      if (!navItem) {
        return
      }
      if (typeof propValue === 'object' && !Array.isArray(propValue)) {
        navItem[propName] = {...navItem[propName], ...propValue}
      } else {
        navItem[propName] = propValue
      }
      this.$store.commit('updateChangedModel', { basePropName: 'Navigation', args: navigation })
      this.$store.commit('needSaveModel', true)
    },
    // Обновление значения свойств измененной модели
    updateChangedModel(propName, propValue, localValue) {
      let changedModel = {...this.changedModel}
      if (!changedModel || !changedModel['Modules'] || !changedModel['Modules'][this.module]) {
        changedModel =  { 'Modules': {} }
      }
      let args = { }
      args[this.module] = changedModel['Modules'][this.module]
      if (!args[this.module]) {
        args[this.module] = {}
      }
      let page  = undefined
      if (args[this.module].Pages && args[this.module].Pages.length) {
        page = args[this.module].Pages.find(x => x['$ID'] === this.$route.params.pageId)
      }
      if (this.readonly && page) {
        // Обновление свойств страниц в changedModel
        if (localValue.$Type === 'dr-page') {
          page[propName] = propValue
          this.$store.commit('updateChangedModel', { basePropName: 'Modules', args })
          this.$store.commit('needSaveModel', true)
          return
        }

        // Обновление свойств виджетов, которые находятся в странице changedModel
        let widgets = this.getWidgetsFromPage(page)
        let foundWidget = deepSearchWidget(widgets, localValue['$ID'])
        if (!foundWidget) {
          return
        }
        foundWidget[propName] = propValue
        this.$store.commit('updateChangedModel', { basePropName: 'Modules', args })
        this.$store.commit('needSaveModel', true)
        return
      }

      // УВАГА. Замінити на $ID
      // updating the properties of widgets that are in snippets
      let snippet = args[this.module]?.Snippets?.find(x => x.Name === this.$route.params.snippetName)
      if (this.readonly && snippet) {
        let foundWidget = deepSearchWidget([snippet.Model], localValue['$ID'])
        if (!foundWidget) {
          return
        }
        foundWidget[propName] = propValue
        this.$store.commit('updateChangedModel', { basePropName: 'Modules', args })
        this.$store.commit('needSaveModel', true)
        return
      }

      // Проверка на существование свойства WidgetPropertiesOverrides
      if (!args[this.module].WidgetPropertiesOverrides) {
        args[this.module] = { WidgetPropertiesOverrides: [] }
      }
      // Обработка переопределений свойст виджетов системных страниц
      let searchWidget = args[this.module].WidgetPropertiesOverrides.find(x => x['$ID'] === localValue['$ID'])
      if (!searchWidget) {
        // Создание объекта виджет
        let widget = { }
        widget['$ID'] = localValue['$ID']
        widget[propName] = propValue

        args[this.module].WidgetPropertiesOverrides.push(widget)
      } else {
        searchWidget[propName] = propValue
      }
      this.$store.commit('updateChangedModel', { basePropName: 'Modules', args })
      this.$store.commit('needSaveModel', true)
    },
    getWidgetsFromPage(page) {
      let widgets = []
      for (let i in page.LayoutCalls) {
        widgets = widgets.concat(page.LayoutCalls[i].Widgets)
      }
      return widgets
    }
  }
}
